import { render, staticRenderFns } from "./CartTotal.vue?vue&type=template&id=468d66a7"
import script from "./CartTotal.vue?vue&type=script&lang=ts"
export * from "./CartTotal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports